const isLocalhost = window.location.hostname.includes("localhost") || window.location.hostname.includes("127.0.0.1");

export const trackFacebookPixelEvent = (type: string) => {
  if (isLocalhost) {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).fbq("trackCustom", type);
};
